import React, { useState } from "react";
import { withNamespaces } from "react-i18next";
import { Alert } from "reactstrap";
import PlatformUpdateCard from "./PlatformUpdateCard";
import PlatfromUpdateModal from "./PlatformUpdateModal";

const PlatformUpdateList = (props) => {
    const { updates, t } = props;
    const [selectedUpdate, setSelectedUpdate] = useState();

    if (updates && updates.length === 0){
        return (
            <Alert color="warning">
                <i className="ri-alert-line me-2 font-size-24 align-middle" />
                {t("Nothing new for now. We'll keep you posted.")}
            </Alert>
        );
    } 

    return (
        <>
            <div className="card-list">
                {updates.map((update, index) => (
                    <PlatformUpdateCard
                        key={update.id}
                        update={update}
                        setSelectedUpdate={setSelectedUpdate}
                    />
                ))}

                <PlatfromUpdateModal
                    selectedUpdate={selectedUpdate}
                    setSelectedUpdate={setSelectedUpdate}
                />
            </div>
        </>
    );
};

export default withNamespaces()(PlatformUpdateList);
